import { useEffect, useState } from 'react';
import { Container, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import parsePrices from 'functions/parseSWPrices';
import ProductItem from '../../../products/item-horizontal';
import ProductThumbnail from '../../../products/thumbnail';
import { useTranslation } from 'tools/i18n';
import { getFastDelivery, getStock } from '@functions/elevateOps';
import urlNormalizer from '@tools/urlNormalization';
import { useRouter } from 'next/router';

const useStyles = makeStyles(theme => ({
    wrapper: {
        marginTop: 40,
        [theme.breakpoints.down('xs')]: {
            width: '100%',
        },
    },
    title: {
        marginBottom: 10,
        fontSize: 13,
        fontWeight: 300,
        letterSpacing: 0.5,
        textTransform: 'uppercase',
    },
}), { name: 'ProductCrossSell' });

export default function CrossSell({ productId }) {
    const classes = useStyles();
    const router = useRouter();
    const [ slots, setSlots ] = useState([]);
    const { t } = useTranslation([ 'product-info' ]);

    useEffect(async () => {
        let crossSellData = await fetch(`/api/product/get/cross-sell/${productId}`, {
            method: 'get',
            credentials: 'include',
        });
        let crossSellResults = await crossSellData.json();
        setSlots(crossSellResults.slots);
    }, [ productId ]);

    function getProductPrices(product) {
        return parsePrices(product.calculatedPrices && product.calculatedPrices.length > 0 ? product.calculatedPrices[0] : product.calculatedPrice);
    }

    function urlNormalize(url) {
        return urlNormalizer(url, router.basePath);
    }

    async function onClick(product) {
    }

    function renderSlot(slot) {
        return <div className={classes.wrapper} key={slot.id + '-key'}>
            <Container disableGutters>
                {slot.products.length > 0 &&
                    <Typography className={classes.title}>{t('style-with-title')}</Typography>
                }

                {slot.products.length > 0 &&
                    slot.products.map((product, key) => {
                            /**
                             * @var {ShopwareProduct} product - Single product from the slot
                             */
                            if (!product.available) {
                                return false;
                            }

                            return <ProductItem
                                id={product.id}
                                propertyIds={product.propertyIds}
                                productNumber={product.productNumber}
                                name={product.translated.name}
                                manufacturer={product.brand}
                                link={urlNormalize(`/${product.seoUrls?.[0]?.seoPathInfo || 'detail/' + product.id}`)}
                                prices={getProductPrices(product)}
                                image={<ProductThumbnail image={product.cover} size={120} index={0} />}
                                list={{ id: product.id, name: 'cross_sell', location: router.asPath }}
                                categoryBreadcrumb={[]}
                                variants={false}
                                available={product.available}
                                clickCallback={onClick.bind(this, product)}
                                isMobile={false}
                                addToCart={true}
                                lazyHydrate={false}
                                sizes={{ lg: 12, md: 12, sm: 12, xl: 12, xs: 12 }}
                                position={key + 1}
                                key={key}
                                analytics={product?.extensions?.newport?.analytics}
                            />;
                        },
                    )
                }
            </Container>
        </div>;
    }

    return slots && slots.map((slot) => {
        return renderSlot(slot);
    });
}
